<template>
  <header
    class="
      tw-sticky
      tw-top-0
      tw-bg-sf-snow-lighter
      tw-z-10
      tw-flex
      tw-items-center
      tw-px-6
      tw-py-3
      tw-h-[var(--secondary-subheader-height)]
      tw-border-solid
      tw-border-b
      tw-border-x-0
      tw-border-t-0
      tw-border-sf-neutral-lighter-2
    "
  >
    <h3 class="tw-text-base">
      {{ I18n.t('file_preview_sidebar.title') }}
    </h3>

    <div class="tw-ml-auto">
      <SfButtonDs
        variant="tertiary"
        icon-only
        icon-before="xmark"
        :aria-label="I18n.t('common.close')"
        @click="drawerStore.closeRightDrawer"
      />
    </div>
  </header>

  <div
    class="
      tw-p-6 tw-text-sf-neutral
      tw-h-[calc(100%-var(--secondary-subheader-height))]
    "
  >
    <div class="tw-h-full">
      <AttachmentListItem
        v-if="attachment && documentPreview"
        :key="`${attachment.document_id}-${documentPreview?.url}`"
        :single-attachment="true"
        :attachment="attachment"
        :changes-are-disabled="true"
        :document-preview="documentPreview"
        :preview-height="attachmentPreviewHeight()"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useDrawer } from '@app/shared/pinia/drawer'

import { SfButtonDs } from '@silverfin/ui-components'
import AttachmentListItem from '../sidebar-file-attachments/attachment-list-item.vue'

import {
  getMainSubheaderHeight,
  getSecondarySubheaderHeight,
  getStickyHeaderHeight,
} from '@app/utils/domHelpers'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { useSidebarFilePreviewStore } from './store/sidebar-file-preview'
import { storeToRefs } from 'pinia'

const I18n = useI18n()

const drawerStore = useDrawer()

const sidebarFilePreviewStore = useSidebarFilePreviewStore()
const { attachment, documentPreview } = storeToRefs(sidebarFilePreviewStore)
const attachmentPreviewHeight = () => {
  const stickyHeaderHeight = getStickyHeaderHeight()
  const primaryHeaderHeight = getMainSubheaderHeight()
  const secondaryHeaderHeight = getSecondarySubheaderHeight()

  // Hardcoded to 40px
  const attachmentCardHeight = '40px'
  const marginBottom = '50px'

  return `calc(100vh - ${stickyHeaderHeight} - ${primaryHeaderHeight} - ${secondaryHeaderHeight} - ${attachmentCardHeight} - ${marginBottom})`
}
</script>
